
export const unifiedMenu = [
  /* {
    label: 'titles-menu-pages.stocks',
    icon: 'icon-car',
    key: 't-stocks',
    role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['supplier'],
    route: '/campaigns/stocks',
  }, */
  {
    label: 'titles-menu-pages.campaigns',
    icon: 'icon-car',
    key: 't-campaigns-broker',
    role: ['Admin', 'Supervisor', 'Agent'], account_type: ['broker'],
    route: '/campaigns/enabled',
  },
  {
    label: 'titles-menu-pages.campaigns',
    icon: 'icon-bullhorn',
    key: 't-campaigns-supplier',
    children: [
      { label: 'titles-menu-pages.drafts', icon: 'icon-plus', role: ['Admin', 'Supervisor', 'Agent'], account_type: ['supplier'], route: '/campaigns/draft', key: 't-drafts' },
      { label: 'titles-menu-pages.enabled', icon: 'icon-check', role: ['Admin', 'Supervisor', 'Agent'], account_type: ['supplier'], route: '/campaigns/enabled', key: 't-enabled' },
      { label: 'titles-menu-pages.under_review', icon: 'icon-eye', role: ['Admin', 'Supervisor', 'Agent'], account_type: ['supplier'], route: '/campaigns/under-review', key: 't-under-review' },
      { label: 'titles-menu-pages.paused', icon: 'icon-stop-circle', role: ['Admin', 'Supervisor', 'Agent'], account_type: ['supplier'], route: '/campaigns/paused', key: 't-paused' },
      { label: 'titles-menu-pages.finished', icon: 'icon-checkmark-circle', role: ['Admin', 'Supervisor', 'Agent'], account_type: ['supplier'], route: '/campaigns/finished', key: 't-finished' },
      { label: 'titles-menu-pages.cancelled', icon: 'icon-cross-circle', role: ['Admin', 'Supervisor', 'Agent'], account_type: ['supplier'], route: '/campaigns/cancelled', key: 't-cancelled' },
      { label: 'titles-menu-pages.all', icon: 'icon-box', role: ['Admin', 'Supervisor', 'Agent'], account_type: ['supplier'], route: '/campaigns/all', key: 't-all-campaigns' },
    ],
  },

  {
    label: 'titles-menu-pages.orders',
    icon: 'icon-clipboard-check',
    key: 't-orders',
    children: [
      { label: 'titles-menu-pages.sqls', icon: 'icon-plus', role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['broker',], route: '/orders/sqls', key: 't-sqls' },
      { label: 'titles-menu-pages.drafts', icon: 'icon-plus', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker'], route: '/orders/drafts', key: 't-drafts' },
      /*   { label: 'titles-menu-pages.offers', icon: 'icon-document', role: ['Admin', 'Supervisor', 'Agent', 'Pre-sales'], account_type: ['broker', 'supplier'], route: '/orders/offers', key: 't-offers' }, */
      { label: 'titles-menu-pages.rejected', icon: 'icon-outbox', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'], route: '/orders/rejected', key: 't-rejected' },
      { label: 'titles-menu-pages.authorized', icon: 'icon-outbox', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'], route: '/orders/authorized', key: 't-authorized' },
      { label: 'titles-menu-pages.denied', icon: 'icon-thumbs-down', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'], route: '/orders/denied', key: 't-denied' },
      { label: 'titles-menu-pages.contracts', icon: 'icon-register', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'], route: '/orders/contracts', key: 't-contracts' },
      { label: 'titles-menu-pages.signed-contracts', icon: 'icon-file-check', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/signed-contracts', key: 't-signed-contracts' },
      { label: 'titles-menu-pages.cancellation_requested', icon: 'icon-bubble-alert', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'], route: '/orders/cancellation-requested', key: 't-cancellation-requested' },
      { label: 'titles-menu-pages.all-contracts', icon: 'icon-box', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'], route: '/orders/all-contracts', key: 't-all-contracts' },
    ],
  },
  {
    label: 'titles-menu-pages.digital',
    icon: 'icon-cloud-download',
    key: 't-digital',
    role: ['Admin', 'Supervisor'],
    account_type: ['broker', 'supplier'],
    route: '/orders/digital',
  },
  {
    label: 'titles-menu-pages.after-sales',
    icon: 'icon-history',
    key: 't-after-sales',
    children: [
      { label: 'titles-menu-pages.after-sales-without-requirement', icon: 'icon-clipboard-empty', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/after-sales-without-requirement', key: 't-after-sales-without-requirement' },
      { label: 'titles-menu-pages.after-sales-factory', icon: 'icon-hammer', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/after-sales-factory', key: 't-after-sales-factory' },
      { label: 'titles-menu-pages.after-sales-billing', icon: 'icon-receipt', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/after-sales-billing', key: 't-after-sales-billing' },
      { label: 'titles-menu-pages.after-sales-registering', icon: 'icon-document2', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/after-sales-registering', key: 't-after-sales-registering' },
      { label: 'titles-menu-pages.after-sales-dealership', icon: 'icon-register', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/after-sales-dealership', key: 't-after-sales-dealership' },
      { label: 'titles-menu-pages.after-sales-logistics', icon: 'icon-truck', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/after-sales-logistics', key: 't-after-sales-logistics' },
      { label: 'titles-menu-pages.after-sales-prepared', icon: 'icon-cross-circle', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/after-sales-prepared', key: 't-after-sales-prepared' },
      { label: 'titles-menu-pages.after-sales-rejected', icon: 'icon-cross-circle', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/after-sales-rejected', key: 't-after-sales-rejected' },
      { label: 'titles-menu-pages.not-delivered', icon: 'icon-truck', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/not-delivered', key: 't-not-delivered' },
      { label: 'titles-menu-pages.after-sales-delivered', icon: 'icon-checkmark-circle', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/after-sales-delivered', key: 't-after-sales-delivered' },
      { label: 'titles-menu-pages.all-after-sales', icon: 'icon-box', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'], route: '/orders/all-after-sales', key: 't-all-after-sales' },
    ],
  },
  {
    label: 'titles-menu-pages.workshop',
    icon: 'icon-cog',
    key: 't-workshop',
    children: [
      { label: 'titles-menu-pages.dealership-accessories', icon: 'icon-hammer-wrench', role: ['Admin', 'Supervisor', 'Workshop', 'Logistics'], account_type: ['supplier'], route: '/orders/dealership-accessories', key: 't-workshop-dealership-accessories' },
      { label: 'titles-menu-pages.registering', icon: 'icon-hammer', role: ['Admin', 'Supervisor', 'Workshop', 'Logistics'], account_type: ['supplier'], route: '/orders/registering', key: 't-workshop-registering' },
      { label: 'titles-menu-pages.pre-delivery', icon: 'icon-truck', role: ['Admin', 'Supervisor', 'Workshop', 'Logistics'], account_type: ['supplier'], route: '/orders/pre-delivery', key: 't-workshop-pre-delivery' },
      { label: 'titles-menu-pages.plates', icon: 'icon-document2', role: ['Admin', 'Supervisor', 'Workshop', 'Logistics'], account_type: ['supplier'], route: '/orders/plates', key: 't-workshop-plates' },
      { label: 'titles-menu-pages.documentation', icon: 'icon-folder', role: ['Admin', 'Supervisor', 'Workshop', 'Logistics'], account_type: ['supplier'], route: '/orders/documentation', key: 't-workshop-documentation' },
      { label: 'titles-menu-pages.washing', icon: 'icon-drop2', role: ['Admin', 'Supervisor', 'Workshop', 'Logistics'], account_type: ['supplier'], route: '/orders/washing', key: 't-workshop-washing' },
      { label: 'titles-menu-pages.logistics', icon: 'icon-road-sign', role: ['Admin', 'Supervisor', 'Workshop', 'Logistics'], account_type: ['supplier'], route: '/orders/logistics', key: 't-workshop-logistics' },
    ],
  },
  {
    label: 'titles-menu-pages.telemarketing',
    icon: 'icon-headset',
    key: 't-telemarketing',
    children: [
      { label: 'titles-menu-pages.pending', icon: 'icon-headset', role: ['Supervisor', 'Telemarketing', 'Admin'], account_type: ['supplier'], route: '/orders/telemarketing-pending', key: 't-all-tele-pending' },
      { label: 'titles-menu-pages.done', icon: 'icon-check', role: ['Supervisor', 'Telemarketing', 'Admin'], account_type: ['supplier'], route: '/orders/telemarketing-done', key: 't-all-tele-done' },

    ],
  },
  {
    label: 'titles-menu-pages.calendar',
    icon: 'icon-calendar-empty',
    key: 't-calendar',
    children: [
      {
        label: 'titles-menu-pages.deliverys',
        icon: 'icon-truck',
        role: ['Admin', 'Supervisor', 'Agent', 'Logistics'],
        account_type: ['supplier'],
        route: '/calendar/deliveries',
        key: 't-deliverys'
      },
      {
        label: 'titles-menu-pages.telemarketing',
        icon: 'icon-headset',
        role: ['Admin', 'Supervisor', 'Agent', 'Telemarketing'],
        account_type: ['supplier'],
        route: '/calendar/telemarketing',
        key: 't-telemarketing'
      },
    ],

  },
  {
    label: 'titles-menu-pages.invoices',
    icon: 'icon-copy',
    key: 't-invoices',
    hideOnMobile: true,
    children: [
      { label: 'titles-menu-pages.drafts', icon: 'icon-plus', role: ['Admin', 'Supervisor'], account_type: ['broker',], route: '/invoices/drafts', key: 't-drafts' },
      { label: 'titles-menu-pages.pending', icon: 'icon-register', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'], route: '/invoices/pending', key: 't-pending' },
      { label: 'titles-menu-pages.paid', icon: 'icon-history', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'], route: '/invoices/paid', key: 't-paid' },
      { label: 'titles-menu-pages.cancelled', icon: 'icon-cross-circle', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'], route: '/invoices/cancelled', key: 't-cancelled' },
      { label: 'titles-menu-pages.all', icon: 'icon-box', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'], route: '/invoices', key: 't-all-invoices' },
    ],
  },


  {
    label: 'titles-menu-pages.clients',
    icon: 'icon-user',
    key: 't-clients',
    role: ['Admin', 'Supervisor', 'Agent', 'Sales'], account_type: ['broker'],
    route: '/clients',
  },
  {
    label: 'titles-menu-pages.frozen',
    icon: 'icon-pause-circle',
    key: 't-frozen',
    role: ['Admin', 'Supervisor', 'Agent'], account_type: ['broker', 'supplier'],
    route: '/orders/frozen',
  },
  {
    label: 'titles-menu-pages.cancelled',
    icon: 'icon-cross-circle',
    key: 't-cancelled',
    role: ['Admin', 'Supervisor', 'Agent'], account_type: ['broker', 'supplier'],
    route: '/orders/cancelled',
  },
  {
    label: 'titles-menu-pages.communications',
    icon: 'icon-bubble',
    key: 't-communications',
    children: [
      {
        label: 'titles-menu-pages.phone',
        icon: 'icon-telephone',
        role: ['Admin', 'Supervisor', 'Agent', 'Sales'],
        account_type: ['broker', 'supplier'],
        route: '/voip/calls',
        key: 't-phone',
      },
      {
        label: 'titles-menu-pages.email_inbox',
        icon: 'icon-inbox',
        role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'],
        account_type: ['broker', 'supplier'],
        route: '/mail/inbox',
        key: 't-email-inbox',
      },
    ],
  },
  {
    label: 'titles-menu-pages.reports',
    icon: 'icon-chart-bars',
    key: 't-reports',
    hideOnMobile: true,
    role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'],
    route: '/reports',
  },

];
